import React, { useMemo } from 'react';
import { localStorage } from '@fiverr-private/futile';
import { useIsClient } from '@fiverr-private/hooks';
import { Container, Stack } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { useCurrentAnnouncements } from '../../../hooks/useCurrentAnnouncements';
import GoMegaphoneIcon from '../../icons/GoMegaphoneIcon';
import { getAnnouncementsLastSeenKey } from '../utils';

const AnnouncementButtonIcon = ({ size }: { size: number }) => {
    const isClient = useIsClient();
    const { data } = useCurrentAnnouncements();
    const lastVisitAnnouncementsPage = useMemo(() => {
        const { userId, userGuid } = getContext();
        return isClient ? localStorage.get(getAnnouncementsLastSeenKey({ userId, userGuid })) : null;
    }, [isClient]);

    const isLastMessageRead =
        data?.[0]?.createdAt &&
        typeof lastVisitAnnouncementsPage === 'string' &&
        new Date(lastVisitAnnouncementsPage).getTime() < new Date(data[0].createdAt).getTime();
    const shouldShowNotificationCircle = isClient && (!lastVisitAnnouncementsPage || isLastMessageRead);

    return (
        <Stack position="relative" display="inlineFlex">
            <GoMegaphoneIcon size={size} />
            {shouldShowNotificationCircle && (
                <Container
                    position="absolute"
                    top="-2px"
                    right="-2px"
                    transform="translate(50%, -50%)"
                    backgroundColor="pink_700"
                    borderRadius="circle"
                    width="6px"
                    height="6px"
                />
            )}
        </Stack>
    );
};

export { AnnouncementButtonIcon };
